import { useState } from 'react';
import DataErk from '../util/Dialogs/DataErk';
import { UserApi } from '../../services/api';
import { useAuth } from '../context/AuthContext';

const Test = () => {

    const [openErk, setOpenErk] = useState(false);

    const { nutzer } = useAuth();

    const getErkStatus = async () => {
        try {
            const response = await UserApi.checkErk(nutzer.id);
            console.log(response.data)
        } catch (err) {
            console.error('Fehler beim Laden der Übungen:', err);
        }
    }

    return (
        <>
            <button onClick={() => setOpenErk(true)}>
                openDialog
            </button>

            <button onClick={() => getErkStatus()}>
                Api
            </button>
            <DataErk openErk={openErk} setOpenErk={setOpenErk} />
        </>
    )
};

export default Test;